import React from "react";
import LegalLayout from "../components/LegalLayout";

const updatedAt = "10 באוגוסט 2025";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="מדיניות פרטיות – Sitechs" subtitle={`עדכון אחרון: ${updatedAt}`}>
      <section className="space-y-6">
        <h2 className="text-2xl font-bold">מי אנחנו וכיצד ליצור קשר</h2>
        <p>האתר מציג שירותי פיתוח עמודי נחיתה ואתרים מטעם <strong>סייטקס פיתוח – עוסק מורשה 200484954</strong>. כתובתנו: דרך חברון 83, ירושלים, ישראל. טלפון: 058-45678-77, אימייל: service@sitechs.co.il.</p>

        <h2 className="text-2xl font-bold mt-8">איזה מידע אנחנו אוספים</h2>
        <ol className="list-decimal pr-5 space-y-1">
          <li><strong>מידע שמסרתם בטופס יצירת קשר</strong> – שם, טלפון, כתובת אימייל ותוכן ההודעה.</li>
          <li><strong>מידע טכני בסיסי</strong> – קובצי Cookie ומזהים דומים הדרושים לתפקוד האתר (למשל שמירת העדפות, אבטחה ומניעת הונאה).</li>
          <li><strong>כלי צד שלישי פעילים</strong> – אנו משתמשים ב‑Google Tag Manager (GTM), Google Analytics 4 (GA4), Meta Pixel, reCAPTCHA של Google, ו‑WhatsApp Business (כפתור/קישור יצירת קשר). כלים אלה עשויים לאסוף נתוני שימוש פסאודונימיים כגון דפים נצפים, משך ביקור, מכשיר ודפדפן.</li>
        </ol>

        <h2 className="text-2xl font-bold mt-8">מטרות העיבוד והבסיס החוקי</h2>
        <ul className="list-disc pr-5 space-y-1">
          <li>מענה לפניות ומתן הצעות מחיר; ניהול קשרי לקוחות (בסיס: <strong>אינטרס לגיטימי/ביצוע חוזה</strong>).</li>
          <li>שיפור חוויית המשתמש ותפקוד האתר (בסיס: <strong>אינטרס לגיטימי</strong>).</li>
          <li>עמידה בחובות משפטיות (בסיס: <strong>חובה חוקית</strong>).</li>
          <li>שליחת עדכונים/דיוור שיווקי בהסכמתכם המפורשת (בסיס: <strong>הסכמה</strong>).</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8">מסירת מידע לצדדים שלישיים</h2>
        <p>אנו עשויים להעביר מידע לספקים המסייעים לנו בהפעלת האתר והשירותים, למשל: אחסון אתרים/דוא"ל, מערכת פניות/CRM, Google Workspace/Sheets לצורך ניהול לידים, כלי ניתוח, וכן ייעוץ מקצועי (עו"ד/רו"ח). ספקים אלו יעשו שימוש במידע רק לצורך מתן השירות לנו ובכפוף להסכמים מתאימים.</p>

        <h2 className="text-2xl font-bold mt-8">העברות מחוץ לישראל</h2>
        <p>ככל שספקים פועלים מחוץ לישראל, המידע עשוי להיות מעובד מחוץ לישראל. אנו נוודא רמת הגנה נאותה בהתאם לדין החל.</p>

        <h2 className="text-2xl font-bold mt-8">שמירת מידע</h2>
        <p>נשמור מידע כל עוד נדרש למטרותיהן נאסף (לרוב עד 36 חודשים מהאינטראקציה האחרונה), או כפי שנדרש בדין/לשמירת ראיות וסוגיות חוזיות. ניתן לבקש מחיקה מוקדמת – בכפוף לחובותינו המשפטיות.</p>

        <h2 className="text-2xl font-bold mt-8">אבטחת מידע</h2>
        <p>אנו מיישמים אמצעי אבטחה סבירים, מנהליים וטכניים, כדי להגן על המידע מפני אובדן, שימוש לרעה או גישה בלתי מורשית. אף על פי כן, אין אבטחה מוחלטת ברשת.</p>

        <h2 className="text-2xl font-bold mt-8">זכויותיכם</h2>
        <p>בהתאם לחוק הגנת הפרטיות בישראל והדין החל, עומדות לכם זכויות כגון: <strong>עיון</strong> במידע, <strong>תיקון</strong> או <strong>מחיקה</strong> של מידע שגוי, וכן <strong>ביטול הסכמה</strong> לדיוור שיווקי. לפניות בנושא זכויות פרטיות: service@sitechs.co.il.</p>

        <h2 className="text-2xl font-bold mt-8">קובצי Cookie וטכנולוגיות דומות</h2>
        <p>ניתן לנהל/לחסום Cookie דרך הגדרות הדפדפן. אנו מפעילים Google Tag Manager, Google Analytics 4, Meta Pixel ו‑reCAPTCHA שעשויים להציב Cookie חיוניים/תפקודיים/מדידה. חסימת Cookie חיוניים עלולה לפגוע בתפקוד האתר. האתר מוגן באמצעות reCAPTCHA של Google, וחלים מדיניות הפרטיות (Privacy Policy) ותנאי השירות (Terms of Service) של Google.</p>

        <h2 className="text-2xl font-bold mt-8">דיוור שיווקי (ספאם)</h2>
        <p>לעיתים רחוקות נשלח עדכונים ותוכן שיווקי בדוא"ל, SMS או WhatsApp, בכפוף להסכמה מראש ובהתאם לחוק התקשורת (בזק ושידורים), תשמ"ב‑1982 (סעיף 30א). בכל הודעה תופיע אפשרות הסרה מיידית (למשל "להסרה" / "הסר" / STOP או קישור הסרה).</p>

        <h2 className="text-2xl font-bold mt-8">קטינים</h2>
        <p>השירות אינו מיועד לקטינים מתחת לגיל 16. אם התבצע איסוף מידע מקטין ללא הסכמת הורה – אנא פנו אלינו למחיקה.</p>

        <h2 className="text-2xl font-bold mt-8">מאגרי מידע ורישומם</h2>
        <p>הלידים נשמרים אצלנו ב‑Google Sheets לצרכי מענה לפניות, קביעת שיחות והצעת שירותים. להבנתנו, בנסיבות פעילותנו אין חובת רישום מאגר בפנקס המאגרים, אולם אם יחול שינוי בדרישות הדין – נפעל בהתאם ונעדכן מדיניות זו.</p>

        <h2 className="text-2xl font-bold mt-8">שינויים במדיניות</h2>
        <p>נעדכן את מדיניות הפרטיות מעת לעת. פרסום הגרסה המעודכנת באתר מהווה הודעה על שינוי.</p>
      </section>
    </LegalLayout>
  );
}